module.exports = __webpack_public_path__ + "static/media/bg-pattern-desktop.a2580ee9.svg";